import BasePaymentEdit from '@/controllers/payment/payment-edit.js';
import CONFIG from "@/assets/js/config.js";
import Vue from 'vue';
import axios from 'axios';

export default {
  extends: BasePaymentEdit,
  data() {
    return {
      inputData: {
        ...BasePaymentEdit.data().inputData,
        item_type: '',
      },
      totalGradeFee: 0,
      noregistrationFee: false,
      prevRegisterFee: {
        cacahe: null,
        value: null,
      },
    };
  },
  methods: {
    getAmt(item_id) {
      var selectedItem = this.itemAmtArr.find(item => item.id == item_id);
      this.putTotalAmount(selectedItem.p_item_amount);
    },

    onItemChange() {
      if (!this.inputData.item_id) return;

      BasePaymentEdit.methods.onItemChange.call(this);
    },

    getDetail() {
      var request = {
        params: {
          campus_id: this.campusId,
          class_id: this.$route.params.classId
        }
      }
      axios.get(`payment/editDetail/${this.$route.params.invoiceId}`, request)
        .then(res => {
          if (res.data) {
            this.inputData.class_id = res.data.class_id;
            this.inputData.student_id = res.data.student_id;
            this.inputData.guardian1_name = res.data.guardian1_name;
            this.paymentData = res.data.payment_data;
            this.paymentDetail = res.data.payment_details;
            this.studentId = res.data.student_id;
            this.student_name = res.data.student_name;
            this.guardian1_name = res.data.guardian1_name;
            this.class_name = res.data.class_name;
            this.totalGradeFee = res.data.total_grade_fee

            if (this.paymentDetail.length) {
              const gradeFeeItem = res.data.payment_details.find(item =>
                item.item_type === CONFIG.PAYMENT_ITEM_TYPE.GRADE_FEE
              );

              if (gradeFeeItem) {
                const totalGradeFee = gradeFeeItem.gross_total_amt ?? null;
                this.prevRegisterFee = {
                  cache: totalGradeFee,
                  value: totalGradeFee,
                };
              }
            }

            if(this.paymentData.discount_type == 1) {
              this.discountFixAmount = parseInt(this.paymentData.discount_amount);
            } else if (this.paymentData.discount_type == 2) {
              this.discountPercent = parseInt(this.paymentData.discount_amount);
            }
            this.isLoading = false;
          }
        })
        .catch(error => {
          this.studentId = null;
          if (error.response) {
            if (error.response.status == 401) {
              this.$store.commit('logout');
              window.location.replace('login');
            }
          }
          this.isLoading = false;
        })
    },

    reset() {
      this.addItem = false;
      if (this.editData.item_id != null) {
        this.addEditData();
      }

      this.prevRegisterFee.value = this.prevRegisterFee.cache;
      this.resetInputData();
    },

    cloneForm() {
      this.editData = [];
      this.addItem = true;
      if (this.$v.inputData.$invalid || this.discountError != "" || this.noregistrationFee) {
        return;
      }
      if (this.paymentDetail.length < 20) {
        const exists = this.paymentDetail.some(detail => detail.item_id == this.inputData.item_id);

        if (!exists) {
          this.paymentDetail.push(Vue.util.extend({}, this.inputData));
        } else {
          this.$notification.error("Payment Item Is Already Exists.", {
            timer: 3,
            position: "bottomCenter"
          });
        }
        this.resetInputData();
      } else {
        alert('Payment can be created at most 20.');
      }
      this.addItem = false;
    },

    removeClone(index, itemType) {
      BasePaymentEdit.methods.removeClone.call(this, index);

      if (itemType == CONFIG.PAYMENT_ITEM_TYPE.GRADE_FEE) {
        this.prevRegisterFee.value = null;
      }
    },

    getTotalPaymentAmount() {
      this.noregistrationFee = false;

      if (Number(this.inputData.item_id)) {
        if (this.inputData.item_type === CONFIG.PAYMENT_ITEM_TYPE.GRADE_FEE) {
          const getTotalGradeFee = this.prevRegisterFee.value ?? this.totalGradeFee;
          if (!getTotalGradeFee) this.noregistrationFee = true;

          this.putTotalAmount(getTotalGradeFee);
          return;
        }
      }

      this.onItemChange();
    },

    putTotalAmount(amount) {
      this.inputData.net_total_amt = amount;
      this.inputData.gross_total_amt = amount;
    }
  },

  watch: {
    'inputData.item_id'() {
      this.inputData.item_type = this.itemArr.find(item => item.id == this.inputData.item_id)?.item_type;
      this.getTotalPaymentAmount();
    },
  },
};
